import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "named-text-fragment-panel col border-left" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "feedback-panel border position-relative p-1 mb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputSelect = _resolveComponent("InputSelect")!
  const _component_InputTextEditor = _resolveComponent("InputTextEditor")!
  const _component_GenericFormWrapper = _resolveComponent("GenericFormWrapper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.namedTextFragment == null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t('new')), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", null, [
        _createVNode(_component_GenericFormWrapper, {
          submitData: _ctx.submitNamedFragmentContent,
          pageUI: _ctx.pageUI,
          hideOverlayAndAlert: true,
          buttonClass: "btn-sm"
        }, {
          content: _withCtx(({errors}) => [
            _createVNode(_component_InputSelect, {
              modelValue: _ctx.localNamedTextFragment.code,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localNamedTextFragment.code) = $event)),
              options: _ctx.enumFragmentNameCode,
              name: _ctx.$t('fragmentCategoryCode'),
              selectText: _ctx.$t('selectText'),
              rules: "required",
              errors: errors
            }, null, 8, ["modelValue", "options", "name", "selectText", "errors"]),
            _createVNode(_component_InputTextEditor, {
              modelValue: _ctx.localNamedTextFragment.fragment.content,
              "onUpdate:modelValue": [
                _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localNamedTextFragment.fragment.content) = $event)),
                _ctx.checkFormDataChanged
              ],
              name: "fragmentContent",
              class: "mb-3",
              errors: errors
            }, null, 8, ["modelValue", "errors", "onUpdate:modelValue"])
          ]),
          buttons: _withCtx(() => [
            _createElementVNode("button", {
              class: "btn btn-sm btn-outline-primary",
              type: "button",
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.submitNamedFragmentCancel()), ["prevent"]))
            }, _toDisplayString(_ctx.$t('cancel')), 1)
          ]),
          _: 1
        }, 8, ["submitData", "pageUI"])
      ])
    ])
  ]))
}